import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { ContactRow } from "../api/relationship.type";
import { getContacts } from "../api/relationships.api";
import { extractUUID } from "../components/utls/utils";
import { useAuth } from "./AuthContext";

function getDependentAccounts(contacts: ContactRow[]) {
  return contacts.filter((contact) => {
    const uuid = extractUUID(contact.related_user.source || "");

    return uuid === contact.user_id;
  });
}

export const useLoadContacts = (): {
  dependentAccounts: ContactRow[];
  contacts: ContactRow[];
  isLoading: boolean;
  isError: boolean;
} => {
  const { user } = useAuth();
  const [dependentAccounts, setDependentAccounts] = useState<ContactRow[]>([]);

  const {
    data: contacts = [],
    isLoading,
    isError,
  } = useQuery<ContactRow[]>({
    queryFn: getContacts,
    queryKey: ["contacts", user?.id],
    enabled: !!user,
    refetchOnWindowFocus: true,
  });

  useEffect(() => {
    if (contacts.length > 0) {
      const da = getDependentAccounts(contacts);
      setDependentAccounts(da);
    }
  }, [contacts]);

  return {
    dependentAccounts,
    contacts,
    isLoading,
    isError,
  };
};
